import { useRef, useEffect, useCallback } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";
import HomePageContainer from "./HomePageContainer";
import Page404 from "./Page404";
import About from "./About";
import PodcastContainer from "./PodcastContainer";
import ProjectSite from "./ProjectSite";
import "../css/application.css";

const App = ({ isIOS }) => {
  const ausweissBitte = useRef(null);
  const romanianCandidacy = useRef(null);
  const navbarRef = useRef(null);

  const getOffset = useCallback((element) => {
    const bounding = element.getBoundingClientRect();
    return {
      top: bounding.top + document.body.scrollTop,
      left: bounding.left + document.body.scrollLeft,
    };
  }, []);

  const handleNavBarScroll = useCallback(() => {
    const startElement = ausweissBitte.current;
    if (!startElement || !navbarRef.current?.outerRef) return;

    const navBarBottom = navbarRef.current.outerRef.getBoundingClientRect().bottom;
    const startOffset = getOffset(startElement);
    const windowScrollTop = window.scrollY;

    if (windowScrollTop >= startOffset.top - navBarBottom) {
      navbarRef.current.handleToggling(true);
    } else {
      navbarRef.current.handleToggling(false);
    }
  }, [getOffset]);

  useEffect(() => {
    if (isIOS) {
      return;
    }

    window.addEventListener("scroll", handleNavBarScroll);

    return () => {
      window.removeEventListener("scroll", handleNavBarScroll);
    };
  }, [isIOS, handleNavBarScroll]);

  return (
    <main role="main">
      <div ref={romanianCandidacy}>
        <NavBar ref={navbarRef} isWhitened={isIOS} />
      </div>
      <div className="withoutBar">
        <div className="appHeader" />
        <div ref={ausweissBitte} />
        <div className="container mainContainer contentWrapper">
          <Routes>
            <Route exact path="/" element={<HomePageContainer />} />
            <Route exact path="/about-me" element={<About />} />
            <Route exact path="/404.html" element={<Page404 />} />
            <Route exact path="/podcasts" element={<PodcastContainer />} />
            <Route exact path="/projects" element={<ProjectSite />} />
            <Route path="*" element={<Navigate to="/404.html" />} />
          </Routes>
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default App;
